<template>
  <div>

    <!-- content -->
    <slot name="header" />

    <section :class="{'padding_top': !noPaddingTop}">
      <slot />
    </section>

    <slot name="footer" />
    <!-- //content -->

  </div>

</template>


<script>
  import PageLayout from 'src/pc/layouts/PageLayout'
  export default {
    extends: PageLayout,
    components: {
    },
    props: {
      noPaddingTop: {
        default: false,
        type: Boolean
      }
    },
  }
</script>

<style>
  .inner {
    padding: 0 15px !important;
    min-width: unset;
  }
</style>